/* eslint-disable no-unused-expressions */
/* eslint-disable no-inner-declarations */
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { searchElementMatch, setNotification } from 'utils';

import {
    loadPackagingRes,
    loadPackagingErr,
    closeOrderItemRes,
    closeOrderItemErr,
    setPackagingIsClosed,
    resetPackagingFiltersRes,
} from '../actions/packagingActions';

import {
    getPackagingApi,
    closeOrderItemApi,
} from '../api/packagingApi';

import {
    LOAD_PACKAGING,
    RESET_PACKAGING_FILTERS,
    CLOSE_ORDER_ITEM,
} from '../types/packagingTypes';

const getLayout = state => state.layout;
const getPackaging = state => state.packaging;

// L O A D   P A C K A G I N G
function* loadPackagingSaga() {
    try {
        const packaging = yield select(getPackaging);

        const { offset, limit, filters, sort } = packaging;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['jobs', 'job_palette']),
        };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'customer_name') {
                params.sort_by = JSON.stringify({ customer_name: sortInt });
            } else if (sort.key === 'quantity') {
                params.sort_by = JSON.stringify({ quantity: sortInt });
            } else if (sort.key === 'expected_shipping_date') {
                params.sort_by = JSON.stringify({ expected_shipping_date: sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            } else if (sort.key === 'design_id') {
                params.sort_by = JSON.stringify({ design_id: sortInt });
            } else if (sort.key === 'order_item_number') {
                params.sort_by = JSON.stringify({ order_item_number: sortInt });
            }
        }

        const filterParams = {};

        if (filters.orderItemId !== '') {
            filterParams.join = {
                order_item_number: filters.orderItemId.trim(),
            };
        }
        if (filters.poNumber !== '') {
            filterParams.join = {
                po_number: filters.poNumber.trim(),
            };
        }
        if (filters.formId !== '') {
            filterParams.join = {
                'forms.form_number': filters.formId.trim(),
            };
        }
        if (filters.jobId !== '') {
            filterParams.join = {
                'jobs.job_number': filters.jobId.trim(),
            };
        }
        if (filters.formVersionId !== '') {
            filterParams.join = {
                'form_versions.form_version_number': filters.formVersionId.trim(),
            };
        }
        if (filters.customer !== '') {
            filterParams.join = {
                customer_name: filters.customer.trim(),
            };
        }

        if (filters.carpetQuality !== '') {
            filterParams['configurations.configurations_property.name'] = searchElementMatch(filters.carpetQuality.trim(), 'fr');
        }

        if (filters.carpetDimension !== '') {
            filterParams['configurations.configurations_property.name'] = searchElementMatch(filters.carpetDimension.trim(), 'fr');
        }

        if (filters.palettes !== '') {
            filterParams.join = {
                'job_palettes.palette_bar_code': filters.palettes.trim(),
            };
        }

        if (filters.totalQuantity !== '') {
            filterParams.join = {
                quantity: parseInt(filters.totalQuantity.trim(), 10),
            };
        }

        if (filters.quantityPrinted !== '') {
            filterParams.join = {
                quantity_printed: filters.quantityPrinted.trim(),
            };
        }

        if (filters.status !== undefined) {
            filterParams.join = {
                state: filters.status,
            };
        }

        if (filters.steps !== undefined) {
            filterParams.join = {
                'steps.machine_name': filters.steps,
            };
        }

        if (filters.startDate !== undefined) {
            filterParams.created_at = {
                between: [`${filters.startDate} 00:00:00`, `${filters.startDate} 23:59:59`],
            };
        }

        if (filters.expectedFinishDate !== undefined) {
            filterParams.join = {
                expected_shipping_date: [`${filters.expectedFinishDate} 00:00:00`],
            };
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getPackagingApi(params);

        yield put(loadPackagingRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(loadPackagingErr());
    }
}

export function* loadPackagingWatcher() {
    yield takeLatest(LOAD_PACKAGING, loadPackagingSaga);
}
// L O A D   P A C K A G I N G


// R E S E T   P A C K A G I N G   F I L T E R S
function* resetPackagingFiltersSaga() {
    try {
        const packaging = yield select(getPackaging);

        const { offset, limit } = packaging;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['jobs', 'job_palette']),
        };

        const result = yield getPackagingApi(params);

        yield put(resetPackagingFiltersRes(result.data));
    } catch (e) {
        yield put(loadPackagingErr());
    }
}

export function* resetPackagingFiltersWatcher() {
    yield takeLatest(RESET_PACKAGING_FILTERS, resetPackagingFiltersSaga);
}
// R E S E T   P A C K A G I N G   F I L T E R S

// C L O S E   O R D E R   I T E M
function* closeOrderItemSaga(action) {
    const { locale } = yield select(getLayout);
    try {
        const result = yield closeOrderItemApi({ order_item_id: action.data });

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'packaging.notification.closeOrderItemSuccess');
            yield put(setPackagingIsClosed(true));
            yield put(closeOrderItemRes());
            yield call(loadPackagingSaga, {});
        } else {
            setNotification('error', locale, 'global.error', 'packaging.notification.closeOrderItemError');
            yield put(closeOrderItemErr());
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'packaging.notification.closeOrderItemError');
        yield put(closeOrderItemErr());
    }
}

export function* closeOrderItemWatcher() {
    yield takeLatest(CLOSE_ORDER_ITEM, closeOrderItemSaga);
}
// C L O S E   O R D E R   I T E M
